/**
 * The /yearly-rashifal/<sign>/ check's own props. Everything the reader sees
 * of the form (its words, its frame, its field ids and its no-time explainer)
 * is the /rashi/<sign>/ check's (components/rashi/rashi-check-form.ts),
 * imported unchanged, so the two checks read the same words and the rashi
 * guides' dates do not move; only the analytics placement, the slot's room
 * and the answer's next steps belong to this page.
 */

/** free_tool_started and calculator_used placement for the yearly page's check. */
export const YEARLY_RASHI_CHECK_PLACEMENT = "yearly_rashifal_page_check";

/**
 * The slot's floor, from the server HTML: the tallest measured state, which
 * every state fills (YearlyRashiCheckLazy has the numbers).
 */
export const YEARLY_RASHI_CHECK_RESERVE = "min-h-[600px] sm:min-h-[500px]";

/**
 * The free annual-chart check a timed answer points to. A plain link: birth
 * details never travel in a URL (lib/last-birth-details.ts); the check saves
 * them on the device, and the /varshphal/ form fills them in from there.
 */
export const VARSHPHAL_HREF = "/varshphal/";

/** The reader's own sign's yearly page. */
export function yearlyRashifalHref(rashi: string): string {
  return `/yearly-rashifal/${rashi}/`;
}
